import React from 'react';
import Loader from "./Loader";

interface Props {
  type: 'button' | 'submit';
  text: string;
  onClick?: () => void;
  containerStyle?: any;
  buttonStyle?: any;
  labelStyle?: any;
  buttonClassName?: string;
  labelStyleClassName?: string;
  disabled?: boolean;
  loading?: boolean;
}

const Button: React.FC<Props> = ({
  text,
  type,
  onClick,
  containerStyle,
  buttonStyle,
  labelStyle,
  buttonClassName,
  labelStyleClassName,
  disabled = false,
  loading = false
}) => {
  return (
    <div className="button-container" style={containerStyle}>
      <button disabled={disabled} className={`button ${buttonClassName}`}  type={type} style={buttonStyle} onClick={onClick}>
        <span className={`button-text ${labelStyleClassName}`} style={labelStyle}>
        {loading ? <Loader color="white"  width={33} height={33}/> : text }
        </span>
      </button>
    </div>
  );
};

export default Button;
